import React from 'react';
import { useDatasourceId, useToggle } from '@/hooks';
import { useGetDrillDownDataTableMutation } from '@/features/drilldown/apiSlice';
import { buildDataTable } from '@/reducers/rows';
import { DrilldownButton } from './DrilldownButton';
import { DrilldownSubTable } from './DrilldownSubTable';

export const DrilldownOption: React.FC<any> = ({
  rowIndex,
  option,
  dataTable,
}) => {
  const datasourceId = useDatasourceId();
  const [expanded, toggleExpanded] = useToggle(false, true);

  const [getDrilldownDataTable, { data, isLoading, error }] =
    useGetDrillDownDataTableMutation();

  const errorMessage = (error as any)?.data?._msg;

  React.useEffect(() => {
    if (expanded) {
      getDrilldownDataTable({
        datasourceId,
        body: {
          _aliases: dataTable._aliases,
          _columnNames: dataTable._headings.map((h: any) => h._columnName),
          _option: option,
          _row: dataTable._rows[rowIndex],
        },
      });
    }
  }, [expanded]);

  return (
    <>
      <tr>
        <td
          className="no-border"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <DrilldownButton
            handleClick={toggleExpanded}
            expanded={expanded}
            rowIndex={rowIndex}
          />
        </td>
        <td className="expand-option">{option.html()}</td>
        {expanded && data?._rowRequestId && (
          <td className="no-border">
            <button
              className="btn btn-outline-dark btn-sm margin-5"
              onClick={() =>
                window.open(
                  `/datasources/${datasourceId}/queries/${data._rowRequestId}`,
                )
              }
            >
              <span className="glyphicon glyphicon-new-window" /> Open results
              in new tab
            </button>
          </td>
        )}
      </tr>
      {expanded && (
        <DrilldownSubTable
          isLoading={isLoading}
          errorMessage={errorMessage}
          dataTable={data?._dataTable ? buildDataTable(data._dataTable) : null}
        />
      )}
    </>
  );
};
